import { baseStoreCreator } from '@/utils/store';

export interface InterestAccrualsPayload {
  interestTemplate: string;
  // Interest template id resolved by the plan read. When "Use HSA Custodian"
  // is selected, the plan still returns a concrete interest_template_id that
  // the tier table must use to display the resolved template's tiers.
  interestTemplateResolvedId: string;
}

export const DEFAULT_VALUES: InterestAccrualsPayload = {
  interestTemplate: 'NONE',
  interestTemplateResolvedId: '',
};

export const useStore = baseStoreCreator<InterestAccrualsPayload>(DEFAULT_VALUES);

export default useStore;
